export default class Iubenda {
  static init() {
    const iubendaBtn = document.querySelector('.iubenda-tp-btn')

    if (iubendaBtn) {
      iubendaBtn.style.zIndex = '1'
    }
  }
}
